import {
  createReqConsts,
  createActions,
  createReqWatcher,
  createReqReducer,
} from '../../../utils/redux';

const makeDeleteCardConfig = () => ({
  endpoint: 'users',
  type: 'delete',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'accountvaults',
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});

const requestOptions = makeDeleteCardConfig();

export const consts = createReqConsts('payment-methods', 'delete-card');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/payment-methods/requests/delete-card-req.js